module.exports = __webpack_public_path__ + "static/img/logoBottom.c382d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logoBottom.png
// module id = eObW
// module chunks = 12